<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' :model='queryForm' ref='form' label-width='80px' :inline='true' size='small'
                 class='query-form' @submit.native.prevent>
            <el-form-item label='支付名称'>
                <el-select
                    v-model="queryForm.payType"
                    placeholder="请选择支付名称"
                    clearable
                    size="small"
                    style="width: 200px"
                >
                    <el-option v-for="item in orderPayTypeEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label='三方渠道'>
                <el-select
                    v-model="queryForm.channelType"
                    placeholder="请选择三方渠道"
                    clearable
                    size="small"
                    style="width: 200px"
                >
                    <el-option v-for="item in payChannelTypeEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label='支付设备'>
                <el-select
                    v-model="queryForm.device"
                    placeholder="请选择支付设备"
                    clearable
                    size="small"
                    style="width: 200px"
                >
                    <el-option v-for="item in deviceTypeEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label='支付位置'>
                <el-select
                    v-model="queryForm.position"
                    placeholder="请选择数值类型"
                    clearable
                    size="small"
                    style="width: 200px"
                >
                    <el-option v-for="item in orderPayPositionEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label='是否开启'>
                <el-select
                    v-model="queryForm.paySwitch"
                    placeholder="请选择数值类型"
                    clearable
                    size="small"
                    style="width: 200px"
                >
                    <el-option v-for="item in yesOrNoEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label='是否拆分'>
                <el-select
                    v-model="queryForm.splitSwitch"
                    placeholder="请选择数值类型"
                    clearable
                    size="small"
                    style="width: 200px"
                >
                    <el-option v-for="item in yesOrNoEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getMppPayList'>查询</el-button>
                <el-button size='small' icon='el-icon-refresh' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button
                        type='primary'
                        size='small'
                        icon='el-icon-plus'
                        @click='addMppPay'
                    >新建
                    </el-button>
                    <el-button
                        type='warning'
                        plain
                        size='small'
                        icon='el-icon-edit'
                        :disabled='multipleSelection.length != 1'
                        @click='editMppPay(null)'
                    >修改
                    </el-button>
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        icon='el-icon-delete'
                        :disabled='multipleSelection.length <= 0'
                        @click='deleteMppPay(null)'
                    >删除
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               class='upload-demo'
                               action='#'
                               :http-request='upload'
                               :show-file-list='true'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title='搜索'
                        class='icon-box'
                        @click='search'
                    >
          <Icon color='#606266'>
            <Search />
          </Icon>
        </span>
                    <!--        <span-->
                    <!--          title="下载模板"-->
                    <!--          class="icon-box"-->
                    <!--          @click="importTemplate"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDown />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          class="icon-box"-->
                    <!--          title="导入数据"-->
                    <!--          @click="isImport"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowExportUp24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="导出数据"-->
                    <!--          class="icon-box"-->
                    <!--          @click="exportMppPayList"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDownload24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <span
                        class='icon-box'
                        @click='refreshMppPayList'
                    >
          <Icon color='#606266'>
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data='mppPayList'
                row-key='id'
                border
                height='100%'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change='handleSelectionChange'
                size='small'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='payName'
                    label='支付名称'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='payType'
                    label='支付数值'
                    width='180'
                >
                    <!-- <template slot-scope='scop'>
                        <div>{{ computeOrderPayType(scop.row.payType) }}</div>
                    </template> -->
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='payLogo'
                    label='支付LOGO'
                    width='180'
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.payLogo'>
                            <el-image
                                @click='updateSrcList(scope.row.payLogo)'
                                style="width: 30px; height: 30px"
                                :src="scope.row.payLogo"
                                :preview-src-list="srcList"
                            > </el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='device'
                    label='支付设备'
                    width='180'
                >
                    <template slot-scope="scope">
                        <div>{{ computeDeviceTypeEnum(scope.row.device) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='position'
                    label='支付位置'
                    width='180'
                >
                    <template slot-scope="scope">
                        <div>{{ computeOrderPayPosition(scope.row.position) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='paySwitch'
                    label='是否开启'
                    width='180'
                >
                    <template slot-scope="scope">
                        <div>{{ computeYesOrNo(scope.row.paySwitch) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='splitSwitch'
                    label='是否拆分'
                    width='180'
                >
                    <template slot-scope="scope">
                        <div>{{ computeYesOrNo(scope.row.splitSwitch) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed='right'
                    align='center'
                    label='操作'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <MgJzD :typeId="scop.row.dictType" style="margin-left: 3px;"></MgJzD>
                            <div @click='checkMppPay(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看</span>
                            </div>
                            <div @click='editMppPay(scop.row.id)'>
                                <Icon size='16'>
                                    <Edit24Regular />
                                </Icon>
                                <span class='operation-label'>修改</span>
                            </div>
                            <div @click='deleteMppPay(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title='mppPayStates[mppPayState]'
                :visible.sync='showDialog'
                width='60%'
                @close='closeDialog'
            >
                <div>
                    <el-form
                        :model='mppPay'
                        ref='mppPayForm'
                        :rules='rules'
                        label-width='120px'
                        :inline='true'
                        size='small'
                    >
                        <!-- <el-form-item
                            label='支付名称'
                            prop='payName'
                        >
                            <el-input
                                size='small'
                                v-model='mppPay.payName'
                                style="width: 200px"
                                :disabled="mppPayState == 'check'"
                            ></el-input>
                        </el-form-item> -->
                        <el-form-item
                            label='支付名称'
                            prop='payType'
                        >
                            <el-select
                                v-model="mppPay.payType"
                                placeholder="请选择数值类型"
                                :disabled="mppPayState == 'check'"
                                clearable
                                size="small"
                                style="width: 200px"
                            >
                                <el-option v-for="item in orderPayTypeEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='货币类型'
                            prop='currencyType'
                            v-if="mppPay.payType == 1"
                        >
                            <el-select
                                v-model="mppPay.currencyType"
                                placeholder="请选择数值类型"
                                :disabled="mppPayState == 'check'"
                                clearable
                                size="small"
                                style="width: 200px"
                            >
                                <el-option v-for="item in currentTypeEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='三方渠道'
                            prop='channelType'
                        >
                            <el-select
                                v-model="mppPay.channelType"
                                placeholder="请选择数值类型"
                                :disabled="mppPayState == 'check'"
                                clearable
                                size="small"
                                style="width: 200px"
                            >
                                <el-option v-for="item in payChannelTypeEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='支付设备'
                            prop='device'
                        >
                            <el-select
                                v-model="mppPay.device"
                                placeholder="请选择支付设备"
                                :disabled="mppPayState == 'check'"
                                clearable
                                size="small"
                                style="width: 200px"
                            >
                                <el-option v-for="item in deviceTypeEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='支付位置'
                            prop='position'
                        >
                            <el-select
                                v-model="mppPay.position"
                                placeholder="请选择支付位置"
                                :disabled="mppPayState == 'check'"
                                clearable
                                size="small"
                                style="width: 200px"
                            >
                                <el-option v-for="item in orderPayPositionEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='是否开启'
                            prop='paySwitch'
                        >
                            <el-select
                                v-model="mppPay.paySwitch"
                                placeholder="请选择是否开启"
                                :disabled="mppPayState == 'check'"
                                clearable
                                size="small"
                                style="width: 200px"
                            >
                                <el-option v-for="item in yesOrNoEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='是否拆分'
                            prop='splitSwitch'
                            v-if="mppPay.position == 4"
                        >
                            <el-select
                                v-model="mppPay.splitSwitch"
                                placeholder="请选择是否拆分"
                                :disabled="mppPayState == 'check'"
                                clearable
                                size="small"
                                style="width: 200px"
                            >
                                <el-option v-for="item in yesOrNoEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="字典类型" prop="dictType">
                            <el-input
                                style="width: 200px"
                                size="small"
                                v-model="mppPay.dictType"
                                :disabled="mppPayState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="排序" prop="sort">
                            <el-input
                                style="width: 200px"
                                size="small"
                                v-model="mppPay.sort"
                                :disabled="mppPayState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='支付LOGO'
                            prop='payLogo'
                        >
                            <el-upload
                                :disabled="mppPayState == 'check'"
                                style="width: 200px"
                                class="avatar-uploader"
                                action=""
                                :show-file-list="false"
                                :http-request="uploadAvatar"
                            >
                                <img v-if="mppPay.payLogo" :src="mppPay.payLogo" class="avatar" size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot='footer'
                    class='flex justify-end'
                >
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button
                        type='primary'
                        @click='submitForm'
                        v-if="mppPayState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post,upload, put, deleteFun } from '@/utils/request.js';
import { UPLOAD_PATH } from '@/utils/constant.js';
import MgJzD from '@/components/model/modelPlace.vue';

export default {
    components: {
        MgJzD,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMppPayList();
                this.getMppPayList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMppPayList();
                this.getMppPayList();
                this.$emit('resetCheckState');
            }
        },
        "mppPay.payType":{
            handler(val){
                if(val != 1){
                    this.mppPay.currencyType = "";
                }
            }
        }
    },
    data() {
        return {
            srcList: [''],
            yesOrNoEnumList: [],
            orderPayPositionEnumList: [],
            orderPayTypeEnumList: [],
            deviceTypeEnumList: [],
            payChannelTypeEnumList: [],
            queryForm: {
                payName: '', //支付名称
                channelType: '',
                payType: '', //支付类型
                payLogo: '', //支付LOGO
                position: '', //位置 1充值 2下单 3向店铺付款 4在店铺下单
                paySwitch: '', //支付开关 1开启 0关闭
                splitSwitch: '', //拆分开关
                device: ''
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mppPayState: 'add',
            mppPayStates: {
                add: '新建支付',
                check: '查看支付',
                edit: '修改支付'
            },

            multipleSelection: [],
            mppPayList: [],
            mppPay: {
                payName: '', //支付名称
                device: '',
                channelType: '',
                payType: '', //支付类型
                payLogo: '', //支付LOGO
                position: '', //位置 1充值 2下单 3向店铺付款 4在店铺下单
                paySwitch: '', //支付开关 1开启 0关闭
                splitSwitch: '', //拆分开关
                dictType: '',
                sort: 1,
                currencyType: ''
            },
            btnLoading: false,
            currentTypeEnumList: [],
            rules: {
                payName: [{ required: true, message: '支付名称不能为空', trigger: 'blur' }],
                device: [{ required: true, message: '支付设备不能为空', trigger: 'blur' }],
                channelType: [{ required: true, message: '支付渠道不能为空', trigger: 'blur' }],
                payType: [{ required: true, message: '支付类型不能为空', trigger: 'blur' }],
                payLogo: [{ required: true, message: '支付LOGO不能为空', trigger: 'blur' }],
                position: [{
                    required: true,
                    message: '位置 1充值 2下单 3向店铺付款 4在店铺下单不能为空',
                    trigger: 'blur'
                }],
                paySwitch: [{ required: true, message: '支付开关 1开启 0关闭不能为空', trigger: 'blur' }],
                splitSwitch: [{ required: true, message: '拆分开关不能为空', trigger: 'blur' }],
                // dictType: [{required: true, message: '字典类型不能为空', trigger: 'blur'}],
                sort: [{required: true, message: '排序不能为空', trigger: 'blur'}],
                currencyType: [{required: true, message: '货币类型不能为空', trigger: 'blur'}]
            }
        };
    },
    created() {
        this.getMppPayList();
        this.getOrderPayTypeEnum();
        this.getOrderPayPositionEnum();
        this.getYesOrNoEnum();
        this.getDeviceTypeEnum();
        this.getPayChannelType();
        this.getCurrentTypeEnumList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        getCurrentTypeEnumList(){
            get('/mpp/utils/getEnum', {
                enumType: 'currency_type'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.currentTypeEnumList = res.enumList;
                }
            });
        },
        resetMppPayList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mppPayList = [];
        },
        resetDialog() {
            this.mppPayState = 'add';
            this.showDialog = false;
            this.queryForm = {
                payName: '', //支付名称
                payType: '', //支付类型
                payLogo: '', //支付LOGO
                position: '', //位置 1充值 2下单 3向店铺付款 4在店铺下单
                paySwitch: '', //支付开关 1开启 0关闭
                splitSwitch: '' //拆分开关
            };
            this.getMppPayList();
        },
        closeDialog() {
            this.showDialog = false;
            this.mppPay = {
                payName: '', //支付名称
                channelType: '',
                payType: '', //支付类型
                payLogo: '', //支付LOGO
                position: '', //位置 1充值 2下单 3向店铺付款 4在店铺下单
                paySwitch: '', //支付开关 1开启 0关闭
                splitSwitch: '', //拆分开关
                dictType: '',
                sort: 1,
                currencyType: ''
            };
        },
        submitForm() {
            if (this.mppPayState == 'add') {
                this.$refs.mppPayForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/pay/add`, { ...this.mppPay }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppPayList();
                                this.resetDialog();
                                this.getMppPayList();
                            }
                        });
                    }
                });
            } else if (this.mppPayState == 'edit') {
                this.$refs.mppPayForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/pay/edit`, { ...this.mppPay }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppPayList();
                                this.resetDialog();
                                this.getMppPayList();
                            }
                        });
                    }
                });
            }
        },
        addMppPay() {
            this.showDialog = true;
            this.mppPayState = 'add';
        },
        checkMppPay(mppPayId) {
            console.log(mppPayId);
            this.currentMppPayId = mppPayId;

            this.getMppPayById();
            this.showDialog = true;
            this.mppPayState = 'check';
        },
        editMppPay(mppPayId) {
            console.log('mppPay', mppPayId);
            if (mppPayId) {
                this.currentMppPayId = mppPayId;
                this.getMppPayById();
            } else {
                this.mppPay = { ...this.mppPay, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mppPayState = 'edit';
        },
        deleteMppPay(mppPayId) {
            let ids = '';
            if (mppPayId) {
                ids = mppPayId;
            } else {
                ids = this.multipleSelection.map((mppPay) => mppPay.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/pay/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMppPayList();
                            this.getMppPayList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMppPayList() {
            this.resetMppPayList();
            this.getMppPayList();
        },
        getMppPayList(query = {}) {
            this.loading = true;
            get(`/mpp/pay/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mppPayList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getMppPayById() {
            get(`/mpp/pay/get`, { id: this.currentMppPayId }).then((res) => {
                if (res.success) {
                    this.mppPay = { ...this.mppPay, ...res.mppPay };
                }
            });
        },
        /**
         * 导出信息
         */
        exportMppPayList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/pay/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/pay/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/pay/importData`, formData);
            this.refreshMppPayList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMppPayList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMppPayList();
        },
        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mppPay.payLogo = res.url;
                }
            });
        },
        updateSrcList(src){
            this.srcList[0] = src
        },

        // 获取 OrderPayTypeEnum
        getOrderPayTypeEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'order_pay_type'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.orderPayTypeEnumList = res.enumList;
                }
            });
        },
        // 获取 OrderPayPosition
        getOrderPayPositionEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'order_pay_position_shop'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.orderPayPositionEnumList = res.enumList;
                }
            });
        },

        // 获取 YesOrNoEnum
        getYesOrNoEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'yes_no'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.yesOrNoEnumList = res.enumList;
                }
            });
        },

        // 获取 deviceTypeEnum
        getDeviceTypeEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'device_type'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.deviceTypeEnumList = res.enumList;
                }
            });
        },

        // 获取 payChannelType
        getPayChannelType() {
            get('/shop/utils/getEnum', {
                enumType: 'pay_channel_type'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.payChannelTypeEnumList = res.enumList;
                }
            });
        },

        computeDeviceTypeEnum(type) {
            for (let i = 0; i < this.deviceTypeEnumList.length; i++) {
                if (this.deviceTypeEnumList[i].key === type) {
                    return this.deviceTypeEnumList[i].value;
                }
            }
        },

        // 计算OrderPayType
        computeOrderPayType(type) {
            for (let i = 0; i < this.orderPayTypeEnumList.length; i++) {
                if (this.orderPayTypeEnumList[i].key === type) {
                    return this.orderPayTypeEnumList[i].value;
                }
            }
        },

        // 计算OrderPayPosition
        computeOrderPayPosition(type) {
            for (let i = 0; i < this.orderPayPositionEnumList.length; i++) {
                if (this.orderPayPositionEnumList[i].key === type) {
                    return this.orderPayPositionEnumList[i].value;
                }
            }
        },

        // 计算YesOrNo
        computeYesOrNo(type) {
            for (let i = 0; i < this.yesOrNoEnumList.length; i++) {
                if (this.yesOrNoEnumList[i].key === type) {
                    return this.yesOrNoEnumList[i].value;
                }
            }
        },
    }

};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px !important;
    height: 200px !important;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
.avatarWide {
    width: 200px;
    height: 120px;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}

</style>